import { IdentifierDTO } from '@zazume/zzm-base';
import { doGet } from '../../helpers';
import { UserBankPaymentInitialization } from '#/models/bank/UserBankPaymentInitialization';

export const bankPayments = {
  public: {
    getInitializationParams: (bankPaymentId: IdentifierDTO, token: string) => () =>
      doGet<UserBankPaymentInitialization>(`/public/web/bank-payments/initialization/${bankPaymentId}?token=${token}`)
  }
};
